<template>
	<div>
		<div class="d-flex flex-row align-center flex-wrap mb-2">
			<template v-if="isEdit">
				<span class="mr-2">分组：</span>
				<span class="font-weight-medium">{{ groupLabel }}</span>
				<span class="text-caption text-medium-emphasis ml-2">修改时不可更改</span>
			</template>
			<v-combobox
				v-else
				v-model="form.group"
				:items="groupOptions"
				item-title="title"
				item-value="value"
				label="分组"
				hint="可选择已有分组，或直接输入新分组编码"
				persistent-hint
				clearable
				style="max-width: 24rem"
				:error-messages="errors.group"
				hide-details="auto"
			></v-combobox>
			<span v-if="isEdit && errors.group" class="text-error ml-2">{{ errors.group }}</span>
		</div>
		<v-text-field
			label="名称"
			v-model="form.name"
			style="max-width: 24rem"
			placeholder="如：迈赫迪 EK Omnia"
			:error-messages="errors.name"
		></v-text-field>
		<div class="text-subtitle-2 mb-1">取值范围</div>
		<div class="d-flex flex-row align-center flex-wrap">
			<v-text-field
				label="最小值"
				v-model.number="form.min_value"
				type="number"
				class="mr-2"
				style="max-width: 10rem"
				:error-messages="errors.min_value"
			></v-text-field>
			<v-text-field
				label="最大值"
				v-model.number="form.max_value"
				type="number"
				class="mr-2"
				style="max-width: 10rem"
				:error-messages="errors.max_value"
			></v-text-field>
			<v-text-field
				label="步进"
				v-model.number="form.step"
				type="number"
				class="mr-2"
				style="max-width: 8rem"
				hint="默认 1"
				persistent-hint
				:error-messages="errors.step"
			></v-text-field>
			<v-text-field
				label="单位"
				v-model="form.unit"
				style="max-width: 8rem"
				placeholder="格"
				:error-messages="errors.unit"
			></v-text-field>
		</div>
		<div class="d-flex flex-row align-center flex-wrap">
			状态：
			<v-radio-group v-model="form.status" inline dense hide-details="auto">
				<v-radio
					v-for="item in refs['MetadataStatus'] || refs['Status']"
					:key="item.value"
					:label="item.title"
					:value="item.value"
				></v-radio>
			</v-radio-group>
			<v-text-field
				class="ml-4"
				label="排序"
				v-model.number="form.sort_order"
				type="number"
				style="max-width: 8rem"
				hide-details
			></v-text-field>
		</div>
		<v-textarea
			class="mt-2"
			v-model="form.description"
			label="备注"
			rows="2"
			:error-messages="errors.description"
		></v-textarea>
		<slot name="actions" :object="submitObject"></slot>
	</div>
</template>

<script>
import { clone } from 'lodash-es'

function normalizeGroup(g) {
	if (g == null || g === '') return ''
	if (typeof g === 'object') return String(g.value || g.title || '').trim()
	return String(g).trim()
}

export default {
	name: 'MetadataForm',
	props: {
		value: Object,
		errors: { type: Object, default: () => ({}) }
	},
	data() {
		return { form: {}, refs: {} }
	},
	computed: {
		isEdit() {
			return !!this.form?.id
		},
		groupOptions() {
			return this.refs['MetadataGroup'] || this.refs['Group'] || []
		},
		groupLabel() {
			const g = this.form.group
			const found = this.groupOptions.find((t) => t.value === g)
			return found ? `${found.title}（${g}）` : g || '—'
		},
		submitObject() {
			return {
				...this.form,
				group: normalizeGroup(this.form.group)
			}
		}
	},
	mounted() {
		this.syncForm(this.value)
		this.$api.common.meta('metadata', 'MetadataGroup,MetadataStatus', (res) => {
			this.refs = res
		})
	},
	watch: {
		value: {
			handler(val) {
				this.syncForm(val)
			},
			immediate: true
		}
	},
	methods: {
		syncForm(val) {
			this.form = clone(val || {})
			this.form.group = normalizeGroup(this.form.group || this.form.type || 'grinder')
			delete this.form.type
			if (!this.form.status) this.form.status = 'valid'
			if (this.form.step == null || this.form.step === '') this.form.step = 1
			if (this.form.min_value == null || this.form.min_value === '') this.form.min_value = 0
			if (this.form.max_value == null || this.form.max_value === '') this.form.max_value = 999
			if (this.form.sort_order == null || this.form.sort_order === '') this.form.sort_order = 0
		}
	}
}
</script>
